/*tslint:disable:max-line-length*/
import { ISchedule, IScheduleItem } from "@/typings/timit";
import moment from 'moment';
import ScheduleItem from './ScheduleItem';

export default class Schedule implements ISchedule {
  id: number;
  passengerId: number;
  name: string;
  startDate: Date | string;
  endDate: Date | string;
  schedulesExternallyEditable: boolean;
  scheduleItems: ScheduleItem[];

  // Editing detection
  private originalName: string;
  private originalStartDate: Date | string;
  private originalEndDate: Date | string;
  private originalSchedulesExternallyEditable: boolean;

  constructor(options) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.id = options && options.id ? options.id : 0;

    this.passengerId = options && options.passengerId ? options.passengerId : 0;

    this.name = options && options.name ? options.name : '';
    this.originalName = this.name;

    this.startDate = options && options.startDate 
    ? moment(options.startDate).startOf('day').format('YYYY-MM-DD') 
    : moment(today).startOf('day').format('YYYY-MM-DD');

    this.originalStartDate = this.startDate;

    this.endDate = options && options.endDate 
    ? moment(options.endDate).startOf('day').format('YYYY-MM-DD') 
    : moment(new Date(today).setDate(today.getDate() + 1)).startOf('day').format('YYYY-MM-DD');

    this.originalEndDate = this.endDate;

    this.scheduleItems = options && options.scheduleItems 
    ? (options.scheduleItems as IScheduleItem[]).map(si => new ScheduleItem(si)) 
    : [];

    this.schedulesExternallyEditable = options && options.schedulesExternallyEditable ? options.schedulesExternallyEditable : false;
    this.originalSchedulesExternallyEditable = this.schedulesExternallyEditable;
  }

  get startDateYMD() {
    return moment(this.startDate).format('YYYY-MM-DD');
  }

  set startDateYMD(val) {
    this.startDate = moment(val).startOf('day').format('YYYY-MM-DD');
  }

  get endDateYMD() {
    return moment(this.endDate).format('YYYY-MM-DD');
  }

  set endDateYMD(val) {
    this.endDate = moment(val).startOf('day').format('YYYY-MM-DD');
  }

  get isExpired() {
    const today = moment().startOf('day').format('YYYY-MM-DD');
    return moment(today).isAfter(this.endDate);
  }

  public static fromApi(apiSchedule: ISchedule) {
    return new Schedule(apiSchedule);
  }

  get isEdited() {
    if (this.id === 0) {
      return true;
    }

    if (this.originalName !== this.name) {
      return true;
    }

    if (this.originalStartDate !== this.startDate) {
      return true;
    }
    if (this.originalEndDate !== this.endDate) {
      return true;
    }

    if (this.originalSchedulesExternallyEditable !== this.schedulesExternallyEditable) {
      return true;
    }
    
    return this.scheduleItems.some(si => si.isEdited);
  }
}
